import "bootstrap";
import '../components/navbar'
import '../components/cookies'
